import { ROUTES_NAMES } from '@/constants';
import { isAuthenticated, setTokens } from '@/service/cognitoService';
import store from '@/store';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

const beforeEnterOtpRoute = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): Promise<void> => {
  const clientId = to.query.client_id;
  const redirectURI = to.query.redirect_uri;

  store.dispatch('setClientID', clientId);
  store.dispatch('setRedirectURI', redirectURI);

  if (!clientId || !redirectURI) {
    return next({ name: ROUTES_NAMES.error });
  }

  const userIsAuthenticated = await isAuthenticated();

  if (!userIsAuthenticated) {
    return next({
      name: ROUTES_NAMES.login,
      query: {
        client_id: clientId,
        redirect_uri: redirectURI
      }
    });
  }
  await setTokens();
  next();
};

export { beforeEnterOtpRoute };
